<template>
	<div
		v-bind="$attrs"
		class="min-w-fit cursor-default"
		:class="[
			backgroundColor,
			textColor,
			fontWeight,
			fontSize,
			lineHeight,
			shadow,
			rounded,
			size === 3 ? 'px-1 py-1' : '',
			size === 4 ? 'px-2 py-1' : '',
			size === 5 ? 'px-3 py-2' : '',
		]"
	>
		<div class="flex items-center">
			<slot>Badge</slot>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	backgroundColor: {
		type: String,
		default: 'bg-blue-400',
		required: false,
	},
	textColor: {
		type: String,
		default: 'text-white',
		required: false,
	},
	fontWeight: {
		type: String,
		default: 'font-medium',
		required: false,
	},
	fontSize: {
		type: String,
		default: 'text-xsm',
		required: false,
	},
	shadow: {
		type: String,
		default: '',
		required: false,
	},
	rounded: {
		type: String,
		default: 'rounded',
		required: false,
	},
	lineHeight: {
		type: String,
		default: 'leading-none md:leading-tight',
		required: false,
	},
	size: {
		type: Number,
		default: 4,
		required: false,
		validator: (value) => [3, 4, 5].includes(value),
	},
})

const emits = defineEmits(['click'])
</script>
